import { ChangeDetectionStrategy, Component, TemplateRef, contentChild, input, viewChild } from "@angular/core";

@Component({
    selector: "app-step",
    template: `
        <ng-template>
            <ng-content></ng-content>
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class StepComponent {
    label = input<string>("");
    disabled = input<boolean>(false);

    _lazyContent = contentChild<TemplateRef<unknown>>("lazyLoad");
    _content = viewChild.required<TemplateRef<unknown>>(TemplateRef);

    get content(): TemplateRef<unknown> {
        return this._lazyContent() ?? this._content();
    }
}
